import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Get Brand Settings
export async function loadAgencySettingsApi(user_id) {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);

    const res = await axios.post(
      `${apiBaseUrl}agencysettingsapis/get_agency_settings`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}


// ✅ Save / Update Agency Settings
export async function saveAgencySettingsApi(payload) {
  try {
    const fd = new FormData();

    fd.append("agset_user", payload.agset_user || "");

    fd.append("agset_company_name", payload.agset_company_name || "");
    fd.append("agset_company_logo", payload.agset_company_logo || "");
    fd.append("agset_brand_color", payload.agset_brand_color || "");

    fd.append("agset_default_platform", payload.agset_default_platform || "");
    fd.append("agset_default_category", payload.agset_default_category || "");

    fd.append("agset_min_followers", payload.agset_min_followers || "");
    fd.append("agset_max_followers", payload.agset_max_followers || "");

    fd.append("agset_default_budget_range", payload.agset_default_budget_range || "");

    fd.append("agset_auto_shortlist", payload.agset_auto_shortlist || "");
    fd.append("agset_show_pricing_estimates", payload.agset_show_pricing_estimates || "");

    fd.append("agset_min_quality_score", payload.agset_min_quality_score || "");
    fd.append("agset_max_risk_score", payload.agset_max_risk_score || "");

    fd.append("agset_preferred_metrics", payload.agset_preferred_metrics || "");
    fd.append("agset_compare_mode_default", payload.agset_compare_mode_default || "");

    fd.append("agset_email_noti", payload.agset_email_noti || "");
    fd.append("agset_push_noti", payload.agset_push_noti || "");

    fd.append("agset_2fa_enabled", payload.agset_2fa_enabled || "");
    fd.append("agset_team_access_enabled", payload.agset_team_access_enabled || "");

    fd.append("agset_updated_by", payload.agset_updated_by || "");

    const res = await axios.post(
      `${apiBaseUrl}agencysettingsapis/save_agency_settings`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}
